import Model from "./base/model";

class SimulationKmRange extends Model {
  resourceName() {
    return "simulation_km_ranges";
  }

  fields() {
    return {
      simulation_table_id: "",
      km_start: "",
      km_end: "",

      simulation_table: {jsonApi: "hasOne", type: "simulation_tables"},
      simulation_values: {jsonApi: "hasMany", type: "simulation_values"},

    };
  }
}

export default new SimulationKmRange();
